import { render } from "./SubscriptionHistory.vue?vue&type=template&id=0231d52e"
import script from "./SubscriptionHistory.vue?vue&type=script&lang=js"
export * from "./SubscriptionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__